<template>
  <t-form labelWidth="80px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
    <e-collapse title="基础设置" :expand="true">
      <t-form-item label="背景颜色">
        <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
          v-model="attribute.bgColor" />
      </t-form-item>
      <t-form-item label="显示复选框">
        <t-radio-group size="small" v-model="attribute.isShowCheckbox">
          <t-radio-button :value="1">是</t-radio-button>
          <t-radio-button :value="0">否</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="显示加载态">
        <t-radio-group size="small" v-model="attribute.isShowLoading">
          <t-radio-button :value="1">是</t-radio-button>
          <t-radio-button :value="0">否</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="悬浮背景色">
        <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
          v-model="attribute.hoverBgColor" />
      </t-form-item>
    </e-collapse>
    <e-collapse title="字体设置" :expand="true">
      <t-form-item label="字体颜色">
        <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
          v-model="attribute.textColor" />
      </t-form-item>
      <t-form-item label="字体样式">
        <t-radio-group size="small" v-model="attribute.fontStyle">
          <t-radio-button value="normal">正常</t-radio-button>
          <t-radio-button value="italic">斜体</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="加粗">
        <t-radio-group size="small" v-model="attribute.fontWeight">
          <t-radio-button value="normal">正常</t-radio-button>
          <t-radio-button value="bold">加粗</t-radio-button>
          <t-radio-button value="lighter">更细</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="字体">
        <t-select size="small" v-model="attribute.fontFamily">
          <t-option v-for="item in textFamilyList" :key="item.value" :label="item.label" :value="item.value" />
        </t-select>
      </t-form-item>
      <t-form-item label="字体大小">
        <t-input-number size="small" :min="0" :max="9999" v-model="attribute.fontSize" :decimal-places="0" />
      </t-form-item>
    </e-collapse>
    <e-collapse title="边框设置" :expand="true">
      <t-form-item label="边框宽度">
        <t-input-number size="small" v-model="attribute.borderSize" :min="0" :max="9999" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="边框颜色">
        <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
          v-model="attribute.borderColor" />
      </t-form-item>
      <t-form-item label="边框左上圆角">
        <t-input-number size="small" v-model="attribute.borderTopLeftRadius" :min="0" :max="9999" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="边框左下圆角">
        <t-input-number size="small" v-model="attribute.borderBottomLeftRadius" :min="0" :max="9999"
          :decimal-places="0" />
      </t-form-item>
      <t-form-item label="边框右上圆角">
        <t-input-number size="small" v-model="attribute.borderTopRightRadius" :min="0" :max="9999"
          :decimal-places="0" />
      </t-form-item>
      <t-form-item label="边框右下圆角">
        <t-input-number size="small" v-model="attribute.borderBottomRightRadius" :min="0" :max="9999"
          :decimal-places="0" />
      </t-form-item>
      <t-form-item label="线条类型">
        <t-select size="small" v-model="attribute.lineType">
          <t-option v-for="item in lineTypeList" :key="item.value" :label="item.label" :value="item.value" />
        </t-select>
      </t-form-item>
      <t-form-item label="是否缓存">
        <t-radio-group v-model="cptDataForm.isCache" size="small">
          <t-radio :value="false">开启</t-radio>
          <t-radio :value="true">关闭</t-radio>
        </t-radio-group>
      </t-form-item>
    </e-collapse>
    <!-- <t-form-item label="背景颜色">
        <t-color-picker
          :colorModes="['monochrome']"
          format="RGBA"
          v-model="attribute.bgColor"
          enableAlpha
          size="small"
        />
      </t-form-item>
      <t-form-item label="圆角">
        <t-input-number
          v-model="attribute.radius"
          :min="0"
          :max="500"
          size="small"
          :decimal-places="0"
        />
      </t-form-item>
      <e-collapse title="字体设置" :expand="true">
        <t-form-item label="字体颜色">
          <t-color-picker
            size="small"
            :colorModes="['monochrome']"
            format="RGBA"
            enableAlpha
            v-model="attribute.textColor"
          />
        </t-form-item>
        <t-form-item label="字体样式">
          <t-radio-group size="small" v-model="attribute.fontStyle">
            <t-radio-button value="normal">正常</t-radio-button>
            <t-radio-button value="italic">斜体</t-radio-button>
          </t-radio-group>
        </t-form-item>
        <t-form-item label="加粗">
          <t-radio-group size="small" v-model="attribute.fontWeight">
            <t-radio-button value="normal">正常</t-radio-button>
            <t-radio-button value="bold">加粗</t-radio-button>
            <t-radio-button value="lighter">更细</t-radio-button>
          </t-radio-group>
        </t-form-item>
        <t-form-item label="字体">
          <t-select size="small" v-model="attribute.fontFamily">
            <t-option
              v-for="item in textFamilyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </t-select>
        </t-form-item>
        <t-form-item label="字体大小">
          <t-input-number
            size="small"
            :min="0"
            :max="9999"
            v-model="attribute.fontSize"
            :decimal-places="0"
          />
        </t-form-item>
      </e-collapse> -->
  </t-form>
</template>

<script>
import CptData from "@/components/element/options/comp/cpt-data";
import CptInputOptionBase from "@/components/element/options/comp/cpt-input-option-base";
export default {
  name: "cpt-button-option",
  props: {
    attribute: Object,
    cptDataForm: Object,
    currentCpt: Object,
  },
  components: { CptData, CptInputOptionBase },
  data() {
    return {};
  },
  created() {
    if (this.attribute.borderRadius) {
      this.attribute.borderTopLeftRadius = this.attribute.borderRadius;
      this.attribute.borderBottomLeftRadius = this.attribute.borderRadius;
      this.attribute.borderTopRightRadius = this.attribute.borderRadius;
      this.attribute.borderBottomRightRadius = this.attribute.borderRadius;
    }
    this.textFamilyList = require("@/assets/font/font-list");
    this.lineTypeList = require("@/assets/data/line-type");
  },
  methods: {},
};
</script>

<style scoped></style>
